import { userHasPermission, userHasRole } from "@accredo/fe-shared/utils/policyUtils.js";

export default {
  viewAny: ({ user }) => {
    return userHasPermission(user, [
      "vertrag_objekt_all",
      "vertrag_objekt_customer",
      "vertrag_objekt_own",
    ]);
  },
  // Kunden-Selbstverwaltung (ACC-323-Folgeticket): kd_verwaltung verwaltet nur
  // die eigenen Bankkonten, nicht die admin-weite Bankkonto-Verwaltung.
  viewOwn: ({ user }) => {
    return userHasRole(user, ["kd_verwaltung"]);
  },
  // Sidebar-Sichtbarkeit für die Admin-Bankkontenverwaltung (/admin/bankaccounts).
  // Bewusst enger als viewAny (das für andere Stellen wie CustomerShowPage.jsx
  // unverändert bleibt): die Seite selbst ist fest auf sysadmin beschränkt
  // (BankAccountsAdministrationPage.jsx), viewAny würde hier auch Rollen ohne
  // tatsächlichen Seitenzugriff einen Link anzeigen.
  viewNavAdmin: ({ user }) => {
    return userHasRole(user, ["sysadmin"]);
  },
};
